import { ContentObserver } from '@angular/cdk/observers';
import { format, parse, compareAsc, compareDesc, parseISO } from 'date-fns';

export class Comparators {

  public static compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  public static sngPlayerComparator(propA, propB) {
    const paArray = propA.replace(/\s/g, '').split('/');
    const pbArray = propB.replace(/\s/g, '').split('/');
    let a = 0;
    let b = 0;
    a = paArray[0] / paArray[1];
    b = pbArray[0] / pbArray[1];
    return (a > b ? -1 : 1);
  }

  public static smartSortingPlayerComparator(propA, propB, isAsc = false): number {
  const paArray = propA.tablePlayers.replace(/\s/g, '').split('/');
  const pbArray = propB.tablePlayers.replace(/\s/g, '').split('/');

  const paRegistered = parseFloat(paArray[0]);
  const paMax = parseFloat(paArray[1]);
  const pbRegistered = parseFloat(pbArray[0]);
  const pbMax = parseFloat(pbArray[1]);

  const aHasPlayers = paRegistered > 0;
  const bHasPlayers = pbRegistered > 0;

  // Grupisanje: stolovi sa igračima idu ispred
  if (aHasPlayers && !bHasPlayers) return -1;
  if (!aHasPlayers && bHasPlayers) return 1;

  // Ako su u istoj grupi (oba imaju igrače ili oba nemaju), sort po stake
  const stakeCompare = propA.minStake - propB.minStake;
  return !isAsc ? stakeCompare : -stakeCompare;
}

  public static playerComparator(a, b, isAsc) {
   const regA = a.NbPlayerRegistered ?? 0;
    const regB = b.NbPlayerRegistered ?? 0;
    const maxA = a.MaxPlayers ?? 0;
    const maxB = b.MaxPlayers ?? 0;

    const aHasPlayers = regA > 0;
    const bHasPlayers = regB > 0;

    if (aHasPlayers && !bHasPlayers) return -1;
    if (!aHasPlayers && bHasPlayers) return 1;

    if (aHasPlayers && bHasPlayers) {
      return isAsc ? regA - regB : regB - regA;
    }
    return isAsc ? maxA - maxB : maxB - maxA;
  }

  public static schedulerComparator(a, b, isAsc) {
    a = parseISO(a);
    b = parseISO(b);

    return isAsc ? compareAsc(a, b) : compareDesc(a, b);
  }

  public static buyInComparator(a, b, isAsc) {
    const getPriority = (item: any): number => {
      if (item.Freeroll === true) return 0;
      if (item.tableBuyIn === '1st Buy In Free') return 1;
      if (item.tableBuyIn === 'Ticket') return 2;
      return 3;
    };

    const priorityA = getPriority(a);
    const priorityB = getPriority(b);

    if (priorityA !== priorityB) return isAsc ? priorityA - priorityB : priorityB - priorityA;

    const feeA = a.EntryFee ?? 0;
    const feeB = b.EntryFee ?? 0;

    return isAsc ? feeA - feeB : feeB - feeA;
  }

  public static statusCompare(a, b, isAsc): number {
  const getPriority = (item: any): number => {
    if (item.Status2 === 2 && item.ImRegistered) return 0;
    if (item.Status2 === 4) return 1;
    if (item.Status2 === 3) return 2;
    if (item.Status2 === 2) return 3;
    if (item.Status2 === 1) return 4;
    if (item.Status2 === 5) return 5;
    if (item.Status2 === 6) return 6;
    return 7; 
  };

  const priorityA = getPriority(a);
  const priorityB = getPriority(b);

  return (priorityA < priorityB ? -1 : priorityA > priorityB ? 1 : 0) * (isAsc ? 1 : -1);
}

  public static dateComparator(a, b, isAsc) {
    a = new Date(a).getTime();
    b = new Date(b).getTime();

    return this.compare(a, b, isAsc)
  }

  public static startInComparator(a: number, b: number, isAsc: boolean): number {
  // Ako su nullish vrednosti, tretiraj ih kao "najveće"
  if (a == null && b == null) return 0;
  if (a == null) return isAsc ? 1 : -1;
  if (b == null) return isAsc ? -1 : 1;

  return isAsc ? a - b : b - a;
}

}


